import conformsTo from 'lodash/conformsTo';
import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

import invariant from 'invariant';
import warning from 'warning';
import createReducer from 'reducers';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

/**
 * Validate the shape of redux store
 */
export function checkStore(store) {
  const shape = {
    dispatch: isFunction,
    subscribe: isFunction,
    getState: isFunction,
    runSaga: isFunction,
    asyncReducers: isObject,
  };
  invariant(
    conformsTo(store, shape),
    '(app/utils...) asyncInjectors: Expected a valid redux store'
  );
}

/**
 * Inject an asynchronously loaded reducer
 */
export function injectAsyncReducer(store, isValid) {
  return function injectReducer(name, asyncReducer) {
    if (!isValid) checkStore(store);

    invariant(
      isString(name) && !isEmpty(name) && isFunction(asyncReducer),
      '(app/utils...) injectAsyncReducer: Expected `asyncReducer` to be a reducer function'
    );

    if (Reflect.has(store.asyncReducers, name)) return;

    store.asyncReducers[name] = asyncReducer; // eslint-disable-line no-param-reassign
    store.replaceReducer(createReducer(store.asyncReducers));
  };
}

/**
 * Inject an asynchronously loaded saga
 */
export function injectAsyncSagas(store, isValid) {
  return function injectSagas(sagas) {
    if (!isValid) checkStore(store);

    invariant(
      Array.isArray(sagas),
      '(app/utils...) injectAsyncSagas: Expected `sagas` to be an array of generator functions'
    );

    warning(
      !isEmpty(sagas),
      '(app/utils...) injectAsyncSagas: Received an empty `sagas` array'
    );

    sagas.map(store.runSaga);
  };
}


const isapplogin = window.location.href.includes('isapp');
export function checkIfLoggedIn(store) {
  return (nextState, replace) => {

    const selectGlobal = store.getState('appReducer').toJS();

    const user = selectGlobal && selectGlobal.appReducer && selectGlobal.appReducer && selectGlobal.appReducer.user && selectGlobal.appReducer.user.userId;


    const thisRoute = nextState.location.pathname.toLowerCase().split('/');
    
    const routeArray = ['', 'signup', 'signin'].includes(thisRoute[1]);

    const hasCookie = cookies.get('userId');


    if (isapplogin) return;


    if (!user && !routeArray && !hasCookie) {
      replace({
        pathname: '/',
        state: { nextPathname: nextState.location.pathname }
      });
    } else if (user && user.organizations && user.organizations.length > 0 && routeArray && !thisRoute.includes('events')) {
      replace({
        pathname: '/organization',
        state: { nextPathname: nextState.location.pathname }
      });
    } else if (hasCookie && nextState.location.pathname === '/') {
      replace({
        pathname: '/organization',
        state: { nextPathname: nextState.location.pathname }
      });
    }
  };
}


/**
 * Helper for creating injectors
 */
export function getAsyncInjectors(store) {
  checkStore(store);

  return {
    checkIfLoggedIn: checkIfLoggedIn(store),
    injectReducer: injectAsyncReducer(store, true),
    injectSagas: injectAsyncSagas(store, true),
  };
}
